export default "__VITE_ASSET__06625cbc__"